import styled from 'styled-components';

export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ul {
    color: ${({ theme }) => theme.colors.black7};
    font-size: 14px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 8px;
  }

  .ant-radio-label {
    font-weight: 500;
  }
`;

export const RadioDescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  margin-top: 4px;
  padding-left: 24px;
`;

export const RadioTitleWrapper = styled.div`
  font-weight: 500;
`;
